import { css, Theme } from '@emotion/react'

export const pagination = (theme: Theme) => css`
  justify-content: center;

  .MuiPagination-ul {
    gap: 10px;
    justify-content: center;
  }

  .MuiPaginationItem-previousNext {
    border-radius: 14px;
    background: ${theme.colors.blue};
    border: none;
    width: 48px;
    height: 48px;
    color: ${theme.colors.white};
  }

  .MuiPaginationItem-page {
    border-radius: 14px;
    width: 48px;
    height: 48px;
    font-weight: 600;
    border: 1px solid ${theme.backgrounds.backgroundOne};
    background: ${theme.backgrounds.backgroundFour};
    box-shadow: ${theme.boxShadows.small};
    color: ${theme.typographyColors.typographyThree};
  }

  .Mui-selected {
    border: 1px solid ${theme.backgrounds.backgroundOne};
    background: ${theme.backgrounds.backgroundFour} !important;
    box-shadow: ${theme.boxShadows.small};
    color: ${theme.colors.blue};
  }

  .Mui-disabled {
    border: 1px solid ${theme.backgrounds.backgroundOne};
    background: ${theme.backgrounds.backgroundFour};
    box-shadow: ${theme.boxShadows.small};
    color: ${theme.typographyColors.typographyThree};
  }
`
